let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("cn2dC")).then(() => parcelRequire('9XBkh'));